export function searchFromString(text: string, phrase: string) {
  return text?.toLowerCase().includes(phrase?.toLowerCase())
}
